import * as tslib_1 from "tslib";
import { updateUserOptions } from 'owa-options-core';
import { getCalendarConfiguration, saveCalendarMailboxConfiguration, updateCalendarMailboxConfiguration, } from 'owa-calendar-configuration';
import { getMeetingDuration } from '../selectors/getMeetingDuration';
import { getReminderTime } from '../selectors/getReminderTime';
import logDataOnSaveEvents from '../utils/logDataOnSaveEvents';
/*
    Called when clicked on save button in calendar settings panel.
    Updates user options so that the changes are reflected in current user session
    Updates the calendar configuration on local store and on server
*/
export default function saveEventOption() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var calendarConfiguration, defaultReminderTime, defaultMeetingDuration;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    calendarConfiguration = getCalendarConfiguration();
                    defaultReminderTime = getReminderTime();
                    defaultMeetingDuration = getMeetingDuration();
                    // update the UserOptions so that changes reflect in current session
                    updateUserOptions({
                        DefaultReminderTimeInMinutes: defaultReminderTime,
                        DefaultMeetingDuration: defaultMeetingDuration,
                    });
                    updateCalendarMailboxConfiguration({
                        DefaultReminderTime: defaultReminderTime,
                        DefaultMeetingDuration: defaultMeetingDuration,
                    });
                    // save the new calendar configuration at server
                    return [4 /*yield*/, saveCalendarMailboxConfiguration(calendarConfiguration)];
                case 1:
                    // save the new calendar configuration at server
                    _a.sent();
                    logDataOnSaveEvents();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=saveEventOption.js.map